import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=7f953d38&scoped=true&"
import script from "./category-list.vue?vue&type=script&lang=js&"
export * from "./category-list.vue?vue&type=script&lang=js&"
import style0 from "./category-list.vue?vue&type=style&index=0&id=7f953d38&prod&lang=scss&"
import style1 from "./category-list.vue?vue&type=style&index=1&id=7f953d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f953d38",
  null
  
)

export default component.exports